import { createAction } from 'typesafe-actions';
import { PredictionWinnerType } from 'widgets/Scoreboard/types';
import { WinnerResult } from 'core/widgets/Winner/types';
import { ACTIONS } from './types';

export const addScoreboardItemAction = createAction(ACTIONS.ADD_NEW_SCOREBOARD_ITEM)<{
  item: WinnerResult;
}>();

export const addScoreboardPredictionAction = createAction(ACTIONS.ADD_SCOREBOARD_PREDICTION)<{
  winner: PredictionWinnerType;
}>();

export const removeScoreboardPredictionAction = createAction(
  ACTIONS.REMOVE_SCOREBOARD_PREDICTION,
)();

export const resetScoreboardStateAction = createAction(ACTIONS.RESET_SCOREBOARD_STATE)();

export const setInitialScoreboardStateAction = createAction(ACTIONS.SET_INITIAL_SCOREBOARD_STATE)<{
  winnersData: WinnerResult[];
}>();
